import type {
  ActionMode,
  DaysActive,
  TimerProfileFormValues,
} from "../components/types";

export const DAYS_ACTIVE_OPTIONS: DaysActive[] = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
  "Weekday",
  "Weekend",
  "Holiday",
  "Everyday",
];

export const ACTION_MODE_OPTIONS: ActionMode[] = ["Auto", "Force On", "Force Off"];

export const DEFAULT_FORM_VALUES: TimerProfileFormValues = {
  name: "",
  startTime: "19:00",
  endTime: "07:00",
  validAllDay: false,
  days: ["Everyday"],
  dimLevel: 0,
  brightLevel: 0,
  actionMode: "Auto",
  zoneId: null,
};
